import styled from "styled-components";
import { useHistory } from "react-router-dom";
import Container from "../../common/Container";
import { Button } from "../../common/Button";
import { BrandLogo } from "../../common/BrandLogo";
import { useDocumentMeta } from "../../common/hooks/useDocumentMeta";
import { color, font, media, size, space } from "../../styles/theme";

const Wrap = styled("div")`
  min-height: 72vh;
  display: grid;
  place-items: center;
  text-align: center;
  /* Symmetric, so place-items actually centres. The old 140px top against a
     ~4rem bottom meant the content sat measurably above the middle of its own
     box; 120px is still clear of the sticky header. */
  padding: 120px 0;
`;

const Inner = styled("div")`
  max-width: 46ch;
  /* Container is width:100%, so the flex/grid centering above only centres
     the Container — this is what actually centres the 46ch column inside it.
     Without it the text sits against the left gutter, centred only within
     its own box. */
  margin-inline: auto;

  img {
    margin: 0 auto ${space.lg};
    opacity: 0.8;
    animation: ghost-flicker 6s linear infinite;
    filter: drop-shadow(0 0 34px rgba(184, 29, 29, 0.4));
  }
`;

const Code = styled("p")`
  font-family: ${font.label};
  font-size: ${size.label};
  letter-spacing: 0.34em;
  text-transform: uppercase;
  color: ${color.bloodBright};
  margin: 0 0 ${space.md};
`;

const Title = styled("h1")`
  font-size: ${size.h2};
  text-transform: uppercase;
  letter-spacing: 0.04em;

  ${media.xs} {
    letter-spacing: 0.02em;
  }
`;

const Actions = styled("div")`
  display: flex;
  flex-wrap: wrap;
  gap: ${space.md};
  justify-content: center;
  margin-top: ${space.xl};
`;

const NotFound = () => {
  const history = useHistory();

  useDocumentMeta({
    title: "Page not found",
    description: "That page isn't here.",
    noIndex: true,
  });

  return (
    <Wrap>
      <Container>
        <Inner>
          <BrandLogo height={38} alt="" />
          <Code>Error 404</Code>
          <Title>Nothing here but the draft</Title>
          <p>
            The page you were looking for isn't at this address. It may have been
            moved, or it may never have existed at all.
          </p>
          <Actions>
            {/* Router pushes rather than <a href> so we don't reload the app. */}
            <Button onClick={() => history.push("/")}>Back to safety</Button>
            <Button variant="ghost" onClick={() => history.push("/terms_of_service")}>
              Terms of Service
            </Button>
          </Actions>
        </Inner>
      </Container>
    </Wrap>
  );
};

export default NotFound;
